module.exports = __webpack_public_path__ + "img/SX.b2d35ce1.svg";